import { getActiveState } from '../../helpers/titreHelper';

const updateVars = (vars, { varnum, countDiff, ...updates }) =>
  vars.map((v) =>
    v.varnum === varnum
      ? {
          ...v,
          ...updates,
          ...(countDiff !== undefined && {
            count: String(Number(v.count || '0') + countDiff),
          }),
        }
      : v,
  );

export const handleVote = (data, refs, setters, optionalParams) => {
  const { voteActiveIdRef } = refs;
  const { setIsVisible, setCurrentState, setVoteState, setIsActive, setVote } =
    setters;
  const { getVoteInfo } = optionalParams;

  switch (data.actionName) {
    case 'VoteEdit':
      const idVote = data.param1;
      const { visibility, state, title } = data.other;
      if (idVote !== voteActiveIdRef.current) return;

      if (visibility !== undefined) setIsVisible(Boolean(Number(visibility)));
      if (state) setCurrentState(getActiveState(state));
      if (title) setVoteState((prev) => ({ ...prev, title }));
      return true;

    case 'VoteStart': {
      const idVote = data.param1;

      if (idVote === voteActiveIdRef.current) {
        setIsActive(true);
      }

      if (idVote !== voteActiveIdRef.current) {
        voteActiveIdRef.current = idVote;
        getVoteInfo?.();
      }
      return true;
    }

    case 'voteCancel': {
      const idVote = data.param1;
      if (idVote !== voteActiveIdRef.current) return;

      setVoteState((prev) => {
        return {
          ...prev,
          vars: prev.vars.map((v) => ({ ...v, count: '0' })),
        };
      });

      // обнуление голоса по метелке
      setVote(idVote, '');
      return true;
    }

    case 'voteSetResult': {
      const idVote = data.param1;
      const varnum = data.param2;

      if (idVote !== voteActiveIdRef.current) return;

      setVoteState((prev) => {
        return {
          ...prev,
          vars: prev.vars.map((v) => ({
            ...v,
            correct: v.varnum === varnum,
          })),
        };
      });

      return true;
    }

    case 'VoteVarUpdate': {
      const { id: idVote, comment, name, varnum } = data.other;
      if (idVote !== voteActiveIdRef.current) return;

      setVoteState((prev) => {
        return {
          ...prev,
          vars: updateVars(prev.vars, {
            varnum,
            comment,
            name,
          }),
        };
      });
      return true;
    }

    case 'voteVarsLoadimg':
    case 'voteVarsDeleteimg': {
      const idVote = data.param1;
      const varnum = data.param2;
      const varImgUrl = data.param3 || null;

      if (idVote !== voteActiveIdRef.current) return;

      setVoteState((prev) => {
        return {
          ...prev,
          vars: updateVars(prev.vars, {
            varnum,
            varImgUrl,
          }),
        };
      });
      return true;
    }

    case 'VoteVarCreate': {
      const { id: idVote, comment, name, num } = data.other;
      if (idVote !== voteActiveIdRef.current) return;

      setVoteState((prev) => ({
        ...prev,
        vars: [
          ...prev.vars,
          {
            comment,
            name,
            varnum: num,
            varImgUrl: null,
            correct: false,
            count: '0',
            id: String(Date.now()),
          },
        ],
      }));
      return true;
    }

    case 'VoteVarDelete': {
      const idVote = data.param1;
      const varnum = data.param2;
      if (idVote !== voteActiveIdRef.current) return;

      setVoteState((prev) => ({
        ...prev,
        vars: prev.vars?.filter((v) => v.varnum !== varnum),
      }));
      return true;
    }

    case 'voteAddVote': {
      const idVote = data.param1;
      const varnum = data.param2;
      if (idVote !== voteActiveIdRef.current) return;

      setVoteState((prev) => {
        return {
          ...prev,
          vars: updateVars(prev.vars, {
            varnum,
            countDiff: 1,
          }),
        };
      });
      return true;
    }

    case 'VoteStop': {
      const idVote = data.param1;
      if (idVote === voteActiveIdRef.current) {
        setIsActive(false);
      }
      return true;
    }

    // case 'AddMessage': {
    //   const { iactiveId: idVote, content } = data.other;
    //   if (idVote !== voteActiveIdRef.current) return;

    //   setVoteState((prev) => {
    //     let varnum = prev.vars.find((v) => {
    //       let keyWords = (JSON.parse(v.name) || []).map((item) =>
    //         item?.trim()?.toLowerCase()
    //       );
    //       return keyWords.includes(strFirstWord(content.toLowerCase()));
    //     })?.varnum;

    //     return {
    //       ...prev,
    //       vars: updateVars(prev.vars, {
    //         varnum,
    //         countDiff: 1,
    //       }),
    //     };
    //   });
    //   return true;
    // }

    default:
      return false;
  }
};
